<template>
  <div class="markItems">
    <div v-for="(currentMark, key) in currentMarks"
         :key="currentMark.id"
         class="markItem"
         :class="{ selected: currentMarks[key]?.isSelected }"
    >
      <h3 class="name" v-if="newVersion">
        <a :href="'/'+pageType+'?keyword='+currentMark.name" >
          #{{ currentMark.name }}
        </a>
      </h3>
      <h3 class="name" v-else>
          #{{ currentMark.name }}
      </h3>
      <img class="icon"
           @click="reviseMark(key, currentMark.id)"
           :src="currentMarks[key]?.isSelected ? 'img/pic/tick.svg' : 'img/pic/plus.svg'"
           alt=""
      />
    </div>
  </div>
</template>

<script>

export default {
  components: {},
  props: {
    marks: {
      type: Array,
      default: () => [],
    },
    newVersion: {
      type: Boolean,
      default: false,
    },
    pageType: {
      type: String,
      default: 'article',
    },
    userMarkIds: {
      type: Array,
      default: () => [],
    },
    authCheck: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    currentMarks: [],
  }),
  computed: {},
  watch: {},
  created() {
    this.currentMarks = this.marks.map((mark) => ({
      ...mark,
      isSelected: this.userMarkIds.includes(mark.id),
    }));
  },
  mounted() {
  },
  methods: {
    async reviseMark(key, id) {
      this.currentMarks[key].isSelected = !this.currentMarks[key].isSelected;

      if (this.authCheck) {
        await this.setMark(id);
      }
    },
    async setMark(id) {
      try {
        await axios.post('api/reviseMark', { id });
      } catch (error) {
        console.warn('Error revising mark:', error);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.markItems {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  .markItem {
    display: flex;
    align-items: center; /* 垂直置中對齊 */
    gap: 8px; /* 設定 name 和 icon 之間的間距 */
    position: relative;
    color: #999;
    border: solid 1px #999;
    border-radius: 5px;
    padding: 5px 8px;
    &.selected, &:hover {
      color: #72ca4a;
      border: solid 1px #72ca4a;
      .name {
        a {
          color: #72ca4a;
        }
      }
    }
    .name {
      margin: 0;
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
      a {
        text-decoration: underline;
        color: #999;
      }
    }
    .icon {
      width: 12px;
      height: 12px;
      cursor: pointer;
    }
  }
}

</style>
